import Box from '@mui/material/Box';
import DropTarget from './drop-target';
import Hash from './hash';
import Header from './Header';
import MapContainer from './map-container';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import Sidebar from './sidebar';
import Typography from '@mui/material/Typography';
import {ACCEPTED_FILE_TYPES} from '../common';
import {connect} from 'react-redux';
import {identify} from '../analytics';
import {setAuthToken} from '@apps-common/js-client/api/request';
import {setByFile as setGeometryByFile} from '../actions/geometry';
import {useAuth} from '@apps-common/auth-react';

const FILE_DRAG_TYPE = 'Files';

const App = props => {
  const [dragging, setDragging] = useState(false);
  const auth = useAuth();
  setAuthToken(auth.user?.accessToken || '');

  useEffect(() => {
    if (!auth.user || auth.pending || auth.error) {
      return;
    }
    identify(auth.user.claims);
  }, [auth]);

  const onDragEnter = event => {
    const types = [...event.dataTransfer.types];
    if (types.includes(FILE_DRAG_TYPE)) {
      setDragging(true);
    }
  };

  const onDragLeave = event => {
    const types = [...event.dataTransfer.types];
    if (types.includes(FILE_DRAG_TYPE)) {
      setDragging(false);
    }
  };

  const onDrop = event => {
    event.preventDefault();
    setDragging(false);

    const types = [...event.dataTransfer.types];
    if (types.includes(FILE_DRAG_TYPE)) {
      props.setGeometryByFile(event.dataTransfer.files[0]);
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      width="100%"
      position="absolute"
      left={0}
      top={0}
    >
      <Header />
      <Box
        display="flex"
        position="relative"
        flexGrow={1}
        onDragEnter={onDragEnter}
      >
        <Sidebar />
        <MapContainer />
        <DropTarget open={dragging} onDrop={onDrop} onDragLeave={onDragLeave}>
          <Typography variant="h5" gutterBottom>
            Drop your file here to define area of interest
          </Typography>
          <Typography variant="h6">
            Accepted filetypes include {ACCEPTED_FILE_TYPES.join(', ')}
          </Typography>
        </DropTarget>
      </Box>
      <Hash />
    </Box>
  );
};

App.propTypes = {
  setGeometryByFile: PropTypes.func,
};

const mapDispatchProps = {
  setGeometryByFile,
};

export default connect(null, mapDispatchProps)(App);
